import { useEffect, useState } from "react";
import appConfig from "../utils/Config";
import axiosConfig from "../utils/axiosConfig";
import List from "@mui/material/List";
import { Alert, AlertTitle, Button, ListItem, ListItemText } from "@mui/material";
import { useNavigate } from "react-router-dom";

const SearchResults = ({ keyword, manualId, handleSearch }) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const url = appConfig.drupal.host


  useEffect(() => {
    const fetchResults = async () => {
      const axios = await axiosConfig();
      setLoading(true)
      try {
        const response = await axios.get(`${url}/api/manuals/search`, {
          params: {
            keyword: keyword,
            manualId: manualId
          }
        })
        if (response.data) {
          setResults(response.data.results)
        }
      } catch (e) {
        console.log(e.text)
      }
      
      setLoading(false)

    }
    fetchResults()
  }, [url, keyword, manualId]);

  function toManual(manualId, pageId, bookmark) {
    handleSearch('')
    navigate(`/manual/${manualId}?page=${pageId}#bookmark_${bookmark}`)
  }

  function toIndex() {
    handleSearch('')
    navigate(`/manual/${manualId}`)
  }

  return (
    <List className="results-list">
      {
        results.map((row) => (
          <ListItem key={row.pageId}>
            <ListItemText sx={{
              '&:last-child td, &:last-child th': { border: 0 },
              '&:hover': { cursor: 'pointer' },
              borderStyle: 'solid',
              borderWidth: '1px',
              borderColor: 'black',
              borderRadius: '10px'
            }}
              primary={row.title}
              secondaryTypographyProps={{ component: 'div' }}
              secondary={
                <div dangerouslySetInnerHTML={{ __html: row.description }} />
              }
              onClick={() => toManual(row.manualId, row.pageId, row.bookmark)}
            />
          </ListItem>
        ))
      }
      {(results.length == 0 && keyword != '' && !loading) ? <Alert severity="info" action={
        <Button color="inherit" size="small" onClick={toIndex}>
          BACK TO INDEX
        </Button>
      }>
        <AlertTitle>
          No results available for current guide with keywords - "<strong>{keyword}</strong>"
        </AlertTitle>
      </Alert> : null}
    </List>
  )

}

export default SearchResults
